// GenomeBrowserTranscriptModal.jsx
export default function TranscriptModal({ data, onClose }) {
  const { gene, transcript, length, strand, five_seq, cds_seq, three_seq, url } = data;

  return (
    <div className="gb-modal-backdrop">
      <div className="gb-modal">
        <h2>{gene}</h2>
        <p><b>Transcript:</b> {transcript}</p>
        <p><b>Length:</b> {length}</p>
        <p><b>Strand:</b> {strand}</p>

        <pre className="gb-sequence">
          <span className="utr-seq"><b>Sequence (CDS in bold):</b>{five_seq}</span>
          <span className="cds-seq">{cds_seq}</span>
          <span className="utr-seq">{three_seq}</span>
        </pre>

        <p><b>Transcript link: </b>
          <a href={url} target="_blank" rel="noreferrer">View profile</a>
        </p>

        <br></br>
        <br></br>
        <br></br>

        <button className="btn btn-secondary btn-md" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

